import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Layout from 'src/components/common/Layout'
import { useSelector } from 'react-redux'
import { selectCTAParams, selectParams } from 'src/modules/reducers/params'
import { selectCountryCode, selectPostalCode } from 'src/modules/reducers/market'
import LivePreviewPlayer from 'src/components/common/LivePreviewPlayer'
import { createUrl } from 'src/modules/utils/createUrl'
import { defaultCTAURI } from 'src/modules/utils/constants'
import HeroCTA from 'src/components/template/live-widget/components/heroCTA'
import { useGetFDPreviewSlug } from 'src/modules/hooks/useGetFDPreviewSlug'

const LiveTemplateDefault = ({ lang = 'en', market = 'all', disableFreeTrial = true }) => {
  const params = useSelector(selectParams)
  const countryCode = useSelector(selectCountryCode)
  const postalCode = useSelector(selectPostalCode)
  const isFanDuel = params?.page_slug === 'FANDUEL'
  const { callsign: fanDuelCallsign } = useGetFDPreviewSlug(isFanDuel ? postalCode : null)

  const [pageSlug, setPageSlug] = useState(null)

  const parsedParams = useSelector(selectCTAParams)
  let ctaURL = 'https://www.fubo.tv' + createUrl(defaultCTAURI, parsedParams)

  useEffect(() => {
    if (isFanDuel && fanDuelCallsign) {
      setPageSlug(fanDuelCallsign)
    } else if (params?.page_slug && params?.page_slug !== 'FANDUEL') {
      setPageSlug(params?.page_slug)
    } else if (countryCode === 'CA' || countryCode === 'CAN') {
      setPageSlug('BEINCHD')
    } else {
      setPageSlug('FS1')
    }
  }, [params?.page_slug, countryCode, isFanDuel, fanDuelCallsign])

  return (
    <Layout lang={lang} market={market} noFooter={true}>
      <StyledLiveWidget>
        <LivePreviewPlayer
          ctaText={disableFreeTrial && 'Learn More'}
          ctaSubhead={disableFreeTrial && 'Keep watching with Fubo.'}
          callsign={pageSlug}
          lang={lang}
        />
        <HeroCTA link={ctaURL} />
      </StyledLiveWidget>
    </Layout>
  )
}

export default LiveTemplateDefault

const StyledLiveWidget = styled.div`
  background-color: #242424;
  color: #242424;
  margin: 0;
  position: relative;
  max-width: 688px !important;
`
